<template>
  <div>
    <FilterForm v-model="filters" @reset="reset"/>

    <hr class="tw-mx-0 tw-my-8">

    <FeaturedStatistics :filters="filters" :portal-company-id="portal.attributes.editorial_portal_company_id"/>

    <TrendedRenderCounts :filters="filters" :portal-company-id="portal.attributes.editorial_portal_company_id"/>

    <RankedContent :filters="filters" :portal-company-id="portal.attributes.editorial_portal_company_id"/>

    <TrendedPublications :filters="filters" :portal-company-id="portal.attributes.editorial_portal_company_id"/>

    <PublishedContent :filters="filters" :portal-company-id="portal.attributes.editorial_portal_company_id"/>

    <TopRenderedContent :filters="filters" :portal-company-id="portal.attributes.editorial_portal_company_id"/>
  </div>
</template>

<script>
import FilterForm from "./Panels/FilterForm.vue";
import moment from 'moment'
import FeaturedStatistics from "./Panels/FeaturedStatistics.vue";
import TopRenderedContent from "./Panels/TopRenderedContent.vue";
import PublishedContent from "./Panels/PublishedContent.vue";
import TrendedPublications from "./Panels/TrendedPublications.vue";
import RankedContent from "./Panels/RankedContent.vue";
import TrendedRenderCounts from "./Panels/TrendedRenderCounts.vue";

export default {
  components: {TrendedRenderCounts, RankedContent, TrendedPublications, PublishedContent, TopRenderedContent, FeaturedStatistics, FilterForm},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      filters: {
        from: moment().format('YYYY-MM'),
        to: moment().format('YYYY-MM'),
      }
    }
  },

  methods: {
    reset() {
      this.filters = {
        from: moment().format('YYYY-MM'),
        to: moment().format('YYYY-MM'),
      }
    },
  }
}
</script>
